$(function () {
	$(".storelist-area-list a").on("click", function (e) {
		e.preventDefault();

		$("html, body").animate({scrollTop: $($(this).attr("href")).offset().top - $("header").height()})
	});

	function setEvent(e) {
		if(e.matches) {
			$(".storelist-area-list-ttl").off("click.showAreas");
			$(".storelist-area-list-content").show();
		}
		else {
			$(".storelist-area-list-content").hide();
			$(".storelist-area-list-ttl").on("click.showAreas", function () {
				let $target	=	$(this);

				$target.addClass("opened").removeClass("closed");

				$(".storelist-area-list-content").stop().slideToggle(function () {
					if(!$(this).is(":visible")) {
						$target.removeClass("opened").addClass("closed");
					}
				});
			});
		}
	}

	let media	=	matchMedia("(min-width:768px)");

	media.addListener(setEvent);

	setEvent(media);
});